export const maskSSN = (ssn) => {
  if (!ssn) return "—";
  const d = String(ssn).replace(/\D/g, "");
  if (d.length >= 4) return `•••-••-${d.slice(-4)}`;
  return "•••-••-••••";
};
